import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

export default function BidsHistory() {
  const [bidList, setBidList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 5;

  useEffect(() => {
    const getMyBid = async () => {
      try {
        const response = await fetch(`/Acution/mybids`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        
        if (Array.isArray(data)) {
          setBidList(data);
        } else if (data.bids && Array.isArray(data.bids)) {
          setBidList(data.bids);
        } else {
          console.error("Unexpected data format:", data);
        }
      } catch (error) {
        console.error("Error fetching bid data:", error);
      }
    };
    getMyBid();
  }, []);
  const totalCount = bidList.length;
  const totalPages = Math.ceil(totalCount / ordersPerPage);

  const indexOfLastBid = currentPage * ordersPerPage;
  const indexOfFirstBid = indexOfLastBid - ordersPerPage;
  const currentBids = bidList.slice(indexOfFirstBid, indexOfLastBid);

  return (
    <Container>
      <Title>내 입찰 현황</Title>
      <OrderList>
        {currentBids.length > 0 ? (
          currentBids.map((order, index) => (
            <OrderItem key={index}>
              <OrderRow>
                <OrderLabel>영화제목:</OrderLabel>
                <OrderValue>{order.movie_title}</OrderValue>
              </OrderRow>
              <OrderRow>
                <OrderLabel>상영관:</OrderLabel>
                <OrderValue>{order.theater}</OrderValue>
              </OrderRow>
              <OrderRow>
                <OrderLabel>인원수:</OrderLabel>
                <OrderValue>{(order.viewer_count || '정보없음')}명</OrderValue>
              </OrderRow>
              <OrderRow>
                <OrderLabel>쿠폰번호:</OrderLabel>
                <OrderValue>{order.coupon_code}</OrderValue>
              </OrderRow>
              <OrderRow>
                <OrderLabel>입찰시간:</OrderLabel>
                <OrderValue>
                  {new Date(order.bid_created_at).toLocaleDateString('ko-KR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </OrderValue>
              </OrderRow>
              <OrderRow>
                <OrderLabel>주문번호:</OrderLabel>
                <OrderValue>{order.order_id}</OrderValue>
              </OrderRow>
              <OrderRow>
                <OrderLabel>경매번호:</OrderLabel>
                <OrderValue>{order.public_order_id}</OrderValue>
              </OrderRow>
              <OrderRow>
                <OrderLabel>금액:</OrderLabel>
                <OrderValue>{order.bid_amount}</OrderValue>
              </OrderRow>
            </OrderItem>
          ))
        ) : (
          <NoDataMessage>입찰 내역이 없습니다.</NoDataMessage>
        )}
      </OrderList>
      {totalCount > 0 && (
        <Pagination>
          <PageButton
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            이전
          </PageButton>
          <PageNumber>
            페이지 {currentPage} / {totalPages}
          </PageNumber>
          <PageButton
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages || totalCount === 0}
          >
            다음
          </PageButton>
        </Pagination>
      )}
    </Container>
  );
}

const NoDataMessage = styled.p`
  text-align: center;
  margin-top: 20px;
  font-size: 18px;
  color: #555;
`;

const Container = styled.div`
  padding: 20px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  border-radius: 10px;
`;

const Title = styled.h1`
  text-align: left;
  color: #333;
  margin-bottom: 20px;
  font-size: 24px;
`;

const OrderList = styled.div`
  margin-top: 20px;
`;

const OrderItem = styled.div`
  padding: 15px;
  margin-bottom: 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const OrderRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;

const OrderLabel = styled.span`
  font-weight: bold;
  color: #555;
`;

const OrderValue = styled.span`
  color: #333;
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const PageButton = styled.button`
  padding: 10px 15px;
  margin: 0 5px;
  background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: #0056b3;
  }
`;

const PageNumber = styled.span`
  margin: 0 10px;
  padding: 10px 0;
  font-size: 16px;
  color: #333;
`;
